import React, { useCallback, useEffect, useRef, useState } from 'react'
import "./pdf-pin.css";
import { ChevronLeft, ChevronRight, Highlighter, HighlighterIcon, Settings2, SquareDashedMousePointer, Trash2, X, Minus, Plus, Link, Move, PanelLeftOpen, PanelRightOpen } from 'lucide-react';
import { Dropdown } from 'primereact/dropdown';
import { MapEntity, useHighlightModelStore, useMergeHighlightModelStore, usePDFAnnotationStore } from '../../store/pdf-pin.store';
import { useNavigate, useParams } from 'react-router-dom';
import { APIResponseEntity } from '../../interface/api-responce';
import { APIForDownloadDrawingPlanPDF, APIGetSystemDDLForDrawing } from '../../service/api-service';
import { toast } from 'react-toastify';
import { toastOptObj } from '../../utils/constants';
import { IsNullOrEmptyArray, IsNullOrUndefined, IsStringNullEmptyOrUndefined } from '../../utils/null-check';
import { AnnotationDrawingPlanEntity, DrawingPlanPDFEntity, PdfHighlighterEntity, PDFTransformEntity, SelectedDrawingAndPageDetailEntity } from '../../interface/pdf-pin';
import Loader from '../../components/loader';
import { getLocalStorageItem, setLocalStorageItem } from '../../service/storage-service';
import { ActionEntityEnum, StorageKeyEnum, SystemLegendsEnumEntity } from '../../utils/enum';
import { Slider } from 'primereact/slider';
import { downloadKeyPointForStroke, downloadPDFWithHighlights, mergeAddedUpdatedAndDeletedCoordinatesDetails, shortUUID } from './utils/pdf-pin.shared';
import { downloadCsvFile, fetchStoredWaltzSolutions, storeWaltzSolutions } from '../../service/shared.service';
import SystemHighlightModel from './components/SystemHighlightModel';
import MergeSystemModel from './components/MergeSystemModel';
import SolutionLinkModel from './components/SolutionLinkModel';
import PDFViewer from './components/PDFViewer';
import { AxiosResponse } from 'axios';
import { GenerateCoordinatesDetailEntity, SolutionDetails } from '../../interface/order';
import { WaltzFeaturedCalculatedSolutionEntity } from '../../interface';
import useOverrideBrowserZoom from '../../hooks/useOverrideBrowserZoom';
import { v4 as uuid4 } from "uuid"

export const MIN_SCALE = 0.5;
export const MAX_SCALE = 3;

const PdfAnnotationPage = () => {

  const { orderId }: any = useParams();

  const pageRef = useRef<HTMLDivElement>(null);

  const [transform, setTransform] = useState<PDFTransformEntity>({
    rotation: 0,
    scale: 1,
    x: 0,
    y: 0
  })

  const navigate = useNavigate();

  const [isDragging, setIsDragging] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [scale, setScale] = useState(1);

  const [initialRecords, setInitialRecords] = useState<MapEntity>();

  const [isSettingOpen, setIsSettingOpen] = useState(false);

  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const { isOpen } = useHighlightModelStore();

  const { isOpen: isMergeModelOpen } = useMergeHighlightModelStore();

  const {
    setSelectedPageId,
    isHighlightsActive,
    selectedHighlight,
    setIsHighlightsActive,
    highlights,
    setSystemDDL,
    deleteHighlight,
    selectedPageId,
    removeHighlightFromPage,
    getHighlightsByPage,
    setHighlights,
    setWidth,
    width,
    isLinkActive,
    setIsLinkActive,
    highlightDataSet,
    clearAllState,
    setHighlightDataSet,
    setIsMoveActive,
    isMoveActive
  } = usePDFAnnotationStore();

  const [drawingDetailFromLocalStorage] = useState<SelectedDrawingAndPageDetailEntity | null>(() => {
    const localStorageDrawingDetail = getLocalStorageItem(StorageKeyEnum.DRAWING_ANNOTATION);
    if (localStorageDrawingDetail && !IsStringNullEmptyOrUndefined(localStorageDrawingDetail)) {
      return JSON.parse(localStorageDrawingDetail);
    }
    return null;
  })

  const [annotationDrawingList, setAnnotationDrawingList] = useState<AnnotationDrawingPlanEntity[] | []>([]);

  const [selectedDrawingDetail, setSelectedDrawingDetail] = useState<AnnotationDrawingPlanEntity | null>(null);

  const [pdfPages, setPdfPages] = useState<DrawingPlanPDFEntity[] | []>([]);

  const [selectedPDFPage, setSelectedPDFPage] = useState<DrawingPlanPDFEntity | null>(null);

  const [annotationUUID] = useState(uuid4());

  const [isShowMenu, setIsShowMenu] = useState(false);


  const [solutionList] = useState<SolutionDetails[] | []>(() => {
    const waltzOrderDetail = fetchStoredWaltzSolutions(orderId);
    if (waltzOrderDetail && !IsNullOrEmptyArray(waltzOrderDetail)) {
      return waltzOrderDetail;
    }
    return []
  })


  const zoomIn = () => setScale((prev) => Math.min(prev + 0.1, MAX_SCALE));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.1, MIN_SCALE));

  const resetZoom = () => setScale(1);


  const fetchSystemDDLForDrawing = async () => {
    setIsLoading(true);
    const resp = await APIGetSystemDDLForDrawing();
    if (!resp || (resp && (resp.status !== 200 || !resp.data))) { return false; }

    const apiRespPayload: APIResponseEntity = resp.data;

    if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
      toast.error(apiRespPayload.message || apiRespPayload.errorMsg,
        { ...toastOptObj });
      setIsLoading(false);
      return;
    }
    const data = apiRespPayload.data.data;
    setSystemDDL(data);
    setIsLoading(false);

  }

  const nextDrawing = () => {
    if (selectedDrawingDetail) {
      const findIndex = annotationDrawingList.findIndex((item) => item.drawingId === selectedDrawingDetail.drawingId);
      if (findIndex !== -1) {
        let nextIndex = (findIndex + 1) % annotationDrawingList.length;

        const findDrawingDetail = annotationDrawingList.findIndex((item, index) => index === nextIndex);
        const drawingDetail = annotationDrawingList[findDrawingDetail];
        setSelectedDrawingDetail(drawingDetail);
        setPdfPages(drawingDetail.PDFs);
        setSelectedPDFPage(drawingDetail.PDFs[0]);
        setSelectedPageId(drawingDetail.PDFs[0].pageId);
        setHighlights(
          getHighlightsByPage(drawingDetail.PDFs[0].pageId)
        );
      }
    }
  }
  const prevDrawing = () => {
    if (selectedDrawingDetail) {
      const findIndex = annotationDrawingList.findIndex((item) => item.drawingId === selectedDrawingDetail.drawingId);
      if (findIndex !== -1) {
        let nextIndex = ((findIndex - 1) + annotationDrawingList.length) % annotationDrawingList.length;

        const findDrawingDetail = annotationDrawingList.findIndex((item, index) => index === nextIndex);
        const drawingDetail = annotationDrawingList[findDrawingDetail];
        setSelectedDrawingDetail(drawingDetail);
        setPdfPages(drawingDetail.PDFs);
        setSelectedPDFPage(drawingDetail.PDFs[0]);
        setSelectedPageId(drawingDetail.PDFs[0].pageId);
        setHighlights(
          getHighlightsByPage(drawingDetail.PDFs[0].pageId)
        )
      }
    }
  }

  const handleChangePDFPage = (value: string) => {
    const selectedPDFDetail = pdfPages.find((item) => item.pageId === value);
    if (selectedPDFDetail && !IsNullOrUndefined(selectedDrawingDetail)) {
      setSelectedPDFPage(selectedPDFDetail);
      setSelectedPageId(selectedPDFDetail.pageId);
      setHighlights(
        getHighlightsByPage(selectedPDFDetail.pageId)
      );

    }
  }



  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    if (!isMoveActive) return;
    if (e.button === 0) { // Left click only
      setIsDragging(true);
      setDragStart({ x: e.clientX - transform.x, y: e.clientY - transform.y });
    }
  }, [transform.x, transform.y, isMoveActive]);

  const handleMouseMove = useCallback((e: React.MouseEvent) => {
    if (!isMoveActive) return;
    if (isDragging) {
      setTransform(prev => ({
        ...prev,
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      }));
    }
  }, [isDragging, dragStart, isMoveActive]);


  async function fetchingDrawingPlanDetailsForAnnotation() {
    setIsLoading(true);

    const data: AnnotationDrawingPlanEntity[] = JSON.parse(getLocalStorageItem(StorageKeyEnum.DRAWING_ANNOTATION_FOR_WALTZ_ORDER) || "[]");
    setAnnotationDrawingList(data);
    let pageId = ""
    if (drawingDetailFromLocalStorage && !IsNullOrUndefined(drawingDetailFromLocalStorage)) {
      const drawingDetail = data.find((item) => item.drawingId === drawingDetailFromLocalStorage.drawingId);
      console.log(drawingDetail, "drawingDetail")
      if (drawingDetail) {
        setSelectedDrawingDetail(drawingDetail);
        setPdfPages(drawingDetail.PDFs);
        const selectedPDFPageDetail = drawingDetail.PDFs.find((item) => item.pageId === drawingDetailFromLocalStorage.pageId);
        if (selectedPDFPageDetail && !IsNullOrUndefined(selectedPDFPageDetail)) {
          setSelectedPDFPage((prev) => (selectedPDFPageDetail as DrawingPlanPDFEntity));
          pageId = selectedPDFPageDetail.pageId
          setSelectedPageId(selectedPDFPageDetail.pageId);


        }
        else {
          setSelectedPDFPage((prev) => drawingDetail.PDFs[0]);
          pageId = drawingDetail.PDFs[0].pageId
          setSelectedPageId(drawingDetail.PDFs[0].pageId);

        }

      } else {
        const drawingDetail = data[0];
        setSelectedDrawingDetail(drawingDetail);
        setPdfPages(drawingDetail.PDFs);
        setSelectedPDFPage(drawingDetail.PDFs[0])
        pageId = drawingDetail.PDFs[0].pageId
        setSelectedPageId(drawingDetail.PDFs[0].pageId);

      }

    } else {
      const drawingDetail = data[0];
      setSelectedDrawingDetail(drawingDetail);
      setPdfPages(drawingDetail.PDFs);
      setSelectedPDFPage(drawingDetail.PDFs[0])
      pageId = drawingDetail.PDFs[0].pageId
      setSelectedPageId(drawingDetail.PDFs[0].pageId);
    }

    const allCoordinates: MapEntity = JSON.parse(getLocalStorageItem(StorageKeyEnum.ANNOTATION_COORDINATES_FOR_WALTZ_ORDER) || '{}');
    setHighlights(allCoordinates[pageId] || []);
    setInitialRecords(allCoordinates);
    setHighlightDataSet(allCoordinates);
    setScale(1);

    setIsLoading(false);
  }


  const handleDownloadKeyPlan = async (highlight: PdfHighlighterEntity) => {
    if (selectedPDFPage) {
      setIsLoading(true);
      await downloadKeyPointForStroke(selectedPDFPage.splitPDFUrl, [highlight], solutionList)
      setIsLoading(false);
    }
  }


  const handleDownloadPDFForFloor = async (type: "with" | "withOut") => {
    if (selectedPDFPage) {
      setIsLoading(true);

      const highlightsData = type === "with" ? highlights.filter((item) => !item.isDraft) : [];
      const files: File | undefined = await downloadPDFWithHighlights(selectedPDFPage.splitPDFUrl, highlightsData, solutionList, 1, false, false);
      if (files) {
        const formData = new FormData();
        let filterHighlight = highlightsData.filter((item) => item.solutionId && !IsStringNullEmptyOrUndefined(item.solutionId));
        formData.append("drawingPlan", files);
        formData.append("totalSystem", filterHighlight.length.toString());
        formData.append("closeSystems", filterHighlight.filter((item) => item.systemId === SystemLegendsEnumEntity.CLOSE).length.toString());
        formData.append("slideSystems", filterHighlight.filter((item) => item.systemId === SystemLegendsEnumEntity.SLIDE).length.toString());
        formData.append("glideSystems", filterHighlight.filter((item) => item.systemId === SystemLegendsEnumEntity.GLIDE).length.toString());
        formData.append("swingSystems", filterHighlight.filter((item) => item.systemId === SystemLegendsEnumEntity.SWING).length.toString());
        formData.append("otherSystems", filterHighlight.filter((item) => !([SystemLegendsEnumEntity.CLOSE, SystemLegendsEnumEntity.SLIDE, SystemLegendsEnumEntity.GLIDE, SystemLegendsEnumEntity.SWING] as string[]).includes(item.systemId)).length.toString());
        formData.append("floorName", selectedPDFPage.splitPDFName);

        const resp: AxiosResponse<APIResponseEntity> = await APIForDownloadDrawingPlanPDF(formData, orderId);

        if (!resp || (resp && (resp.status !== 200 || !resp.data))) { setIsLoading(false); return false; }

        const apiRespPayload: APIResponseEntity = resp.data;

        if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
          toast.error(apiRespPayload.message || apiRespPayload.errorMsg,
            { ...toastOptObj });
          setIsLoading(false);
          return;
        }
        const pdfUrl = apiRespPayload.data.pdfUrl;

        if (pdfUrl) {
          await downloadCsvFile(pdfUrl, pdfUrl.split("/").splice(-1)[0]);
        }
      }

      setIsLoading(false);
    }
  }


  const removeDraftFromHighlights = (highlighSet: MapEntity) => {
    let newData: any = { ...highlighSet };

    for (const key in newData) {
      if (Array.isArray(newData[key])) {
        newData[key] = newData[key].filter((item: any) => !item.isDraft);
        if (newData[key].length === 0) {
          delete newData[key];
        }
      }
    }
    return newData;
  }


  const handlePublishPins = async () => {
    setIsLoading(true);

    const newData = removeDraftFromHighlights(highlightDataSet);

    let coordinate: GenerateCoordinatesDetailEntity[] | [] = [];

    let deleteCoordinatesIds: string[] | [] = [];
    /* Update solution floor name if change */
    if (newData && !IsNullOrUndefined(newData) && initialRecords) {
      const { merged, deletedIds } = mergeAddedUpdatedAndDeletedCoordinatesDetails(initialRecords, newData);
      const existingDeleteIds = JSON.parse(getLocalStorageItem(StorageKeyEnum.ANNOTATION_DELETE_IDS) || "[]");
      setLocalStorageItem(StorageKeyEnum.ANNOTATION_DELETE_IDS, JSON.stringify([...existingDeleteIds, ...deletedIds]));
      coordinate = (Object.values((merged as any)).flatMap((item) => item) as GenerateCoordinatesDetailEntity[]);
      deleteCoordinatesIds = deletedIds;
    }

    const initialCoordinates: any[] = initialRecords ? Object.values(initialRecords).flatMap((item) => item) : [];
    const existingSolutionId = JSON.parse(getLocalStorageItem(StorageKeyEnum.EXISTING_SOLUTIONS_IDS_FOR_DRAWING_PLAN) || "[]");

    const waltzOrderDetail = fetchStoredWaltzSolutions(orderId);
    if (coordinate && !IsNullOrEmptyArray(coordinate)) {
      const drawingFloorList = annotationDrawingList.flatMap((item) => item.PDFs);
      if (waltzOrderDetail && !IsNullOrEmptyArray(waltzOrderDetail)) {
        let updateSolutions: any[] = [];

        for (const element of coordinate) {
          const floorDetail = drawingFloorList.find((item) => item.pageId === element.pageId);
          if (!floorDetail) continue;

          let solutionDetail = waltzOrderDetail.find((item) => item._id === element.solutionId && item.floor !== floorDetail.splitPDFName);

          if (solutionDetail && !IsNullOrUndefined(solutionDetail)) {
            updateSolutions.push({ ...solutionDetail, floor: floorDetail.splitPDFName, actionName: solutionDetail.actionName === ActionEntityEnum.LIST ? ActionEntityEnum.UPDATE : solutionDetail.actionName });
          }

          const initialCoordinatesDetail = initialCoordinates.find((item: any) => item.id === element.id)



          if (initialCoordinatesDetail && !IsNullOrUndefined(initialCoordinatesDetail) && initialCoordinatesDetail.solutionId !== element.solutionId && existingSolutionId.includes(initialCoordinatesDetail.solutionId)) {

            let solutionDetail = waltzOrderDetail.find((item) => item._id === initialCoordinatesDetail.solutionId);

            if (solutionDetail && !IsNullOrUndefined(solutionDetail)) {
              updateSolutions.push({ ...solutionDetail, floor: "", actionName: solutionDetail.actionName === ActionEntityEnum.UPDATE ? ActionEntityEnum.LIST : solutionDetail.actionName });
            }
          }
        }
        /* initial records check remove links or not */
        storeWaltzSolutions(orderId, (updateSolutions as WaltzFeaturedCalculatedSolutionEntity[]));
      }

    }

    /* update for deleted solutions */
    let updateSolutions: any[] = [];
    if (initialCoordinates && !IsNullOrEmptyArray(initialCoordinates) && waltzOrderDetail && !IsNullOrEmptyArray(waltzOrderDetail)) {
      const deletedCoordinatesDetail = initialCoordinates.filter((item) => (deleteCoordinatesIds as string[]).includes(item.id));

      for (const element of deletedCoordinatesDetail) {

        if (element.solutionId && !IsStringNullEmptyOrUndefined(element.solutionId) && existingSolutionId.includes(element.solutionId)) {
          let solutionDetail = waltzOrderDetail.find((item) => item._id === element.solutionId);

          if (solutionDetail && !IsNullOrUndefined(solutionDetail)) {
            updateSolutions.push({ ...solutionDetail, floor: "", actionName: solutionDetail.actionName === ActionEntityEnum.UPDATE ? ActionEntityEnum.LIST : solutionDetail.actionName });
          }
        }

      }

      if (updateSolutions && !IsNullOrEmptyArray(updateSolutions)) {
        storeWaltzSolutions(orderId, (updateSolutions as WaltzFeaturedCalculatedSolutionEntity[]));
      }
    }


    setLocalStorageItem(StorageKeyEnum.ANNOTATION_COORDINATES_FOR_WALTZ_ORDER, JSON.stringify(newData));
    clearAllState();
    navigate(`/manage-wall-order-solution/${orderId}?fromURL=waltz-orders`);

    setIsLoading(false);

  }

  const handleFetchLocationNo = (solutionId: string) => {
    const solutionDetail = solutionList.find((item) => item._id === solutionId);
    if (solutionDetail && !IsNullOrUndefined(solutionDetail)) {
      return `Location ${solutionDetail.solutionNo}`;
    }
  }

  const MenuIcon = () => {
    const Icon = !isShowMenu ? PanelLeftOpen : PanelRightOpen;
    return (
      <button className='split-control-btn' onClick={() => setIsShowMenu(prev => !prev)}>
        <Icon className='cursor-pointer' />
      </button>
    )
  }



  useEffect(() => {
    async function fetchDefaultData() {
      await fetchSystemDDLForDrawing();
      fetchingDrawingPlanDetailsForAnnotation();
    }
    fetchDefaultData()
  }, []);

  useEffect(() => {
    const handleWindowMouseUp = () => {
      setIsDragging(false);
    };

    window.addEventListener("mouseup", handleWindowMouseUp);

    return () => {
      window.removeEventListener("mouseup", handleWindowMouseUp);
    };
  }, []);


  useOverrideBrowserZoom(zoomIn, zoomOut, resetZoom);

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="d-flex flex-column h-100 pin-bg">
        <div className="pin-header-main">
          <div className='d-flex align-items-center gap-4'>
            <div>
              <button className='pin-header-button' onClick={prevDrawing} disabled={annotationDrawingList.length < 2}>
                <ChevronLeft />
              </button>
              <button className='pin-header-button' onClick={nextDrawing} disabled={annotationDrawingList.length < 2}>
                <ChevronRight />
              </button>
            </div>
            <div className='flex-grow-1'>
              <div className='d-flex align-items-center gap-2'>
                <div className='my-auto'>
                  <h4 className='pt-2'>
                    {selectedDrawingDetail && selectedDrawingDetail.drawingName}
                  </h4>
                </div>
                <Dropdown
                  className="custom-dark-dropdown"
                  style={{ width: '400px' }}
                  panelClassName='custom-dark-dropdown'
                  value={selectedPDFPage && selectedPDFPage.pageId}
                  options={pdfPages}
                  optionLabel='splitPDFName'
                  optionValue='pageId'
                  onChange={(e) => handleChangePDFPage(e.value)}
                  placeholder="Select a page"
                />
              </div>
            </div>
            <div className='d-flex align-items-center gap-2'>
              <div className="pdf-annotation dropdown">
                <button
                  className="btn  pin-header-button dropdown-toggle"
                  style={{ fontSize: '15px', padding: "1em 1.5em" }}
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Download
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <button className="dropdown-item" disabled={IsNullOrEmptyArray(highlights.filter((item) => !item.isDraft))} onClick={() => handleDownloadPDFForFloor("with")} >With Highlights</button>
                  <button className="dropdown-item" onClick={() => handleDownloadPDFForFloor("withOut")} >Without Highlights</button>
                </div>
              </div>
              <MenuIcon />
            </div>

          </div>
        </div>
        <div className="flex-shrink-1 h-100 ">
          <div className="d-flex flex-row h-100">
            {/* PDF Viewer */}
            <div className="flex-grow-1 overflow-auto py-4  pdf-viewer overflow-hidden"
            >
              <div className='d-flex  align-items-center mt-5  '>
                <div className='mx-auto'
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  style={{
                    transform: `translate(${transform.x}px, ${transform.y}px) scale(${transform.scale}) `,
                    transformOrigin: 'center',
                    transition: isDragging ? 'none' : 'transform 0.2s ease-out'
                  }}>
                  <div className='position-relative' >
                    {
                      selectedPDFPage && (
                        <PDFViewer onLoadSuccess={() => { }} pageNumber={1} pageRef={pageRef} pdfUrl={selectedPDFPage.splitPDFUrl} scale={scale} isDragging={isDragging} />
                      )
                    }
                  </div >

                </div>
                {/* controller */}
                <div className='pin-annotation-controller'>
                  <div className='d-flex justify-content-between align-items-center mx-5'>
                    {/* button for add Pins */}
                    <div className='d-flex flex-column align-items-center gap-2 '>
                      <button className={isHighlightsActive ? "pin-icon-btn-active" : 'pin-icon-btn'} onClick={() => setIsHighlightsActive(!isHighlightsActive)}>
                        <Highlighter color={'#fff'} size={25} />
                      </button>

                      <div className='position-relative'>
                        {
                          isSettingOpen && (
                            <div style={{ position: "absolute", bottom: "0.5rem", left: "4rem", minWidth: "5rem", backgroundColor: "#36383A", padding: "1rem", borderRadius: "20px" }} onClick={(e) => e.stopPropagation()}>
                              <div className='d-flex align-items-center gap-1 w-100'>
                                <Slider
                                  value={width}
                                  style={{ minWidth: "5rem" }}
                                  min={5}
                                  max={30}
                                  onChange={(e) => setWidth(+e.value)}
                                  className="pin-slider-inside"
                                />
                                {/* <p style={{ color: "#FFF", fontVariantNumeric: "tabular-nums" }} className='ms-1'>{width}</p> */}
                              </div>
                            </div>
                          )
                        }

                        <button className={'pin-icon-btn '} onClick={() => setIsSettingOpen(!isSettingOpen)}>
                          {
                            isSettingOpen ?
                              <X
                                color={'#fff'} size={25}
                              />
                              :
                              <Settings2 />
                          }

                        </button>
                      </div>
                      <button className={isLinkActive ? "pin-icon-btn-active" : 'pin-icon-btn'} onClick={(e) => {
                        e.stopPropagation();
                        setIsLinkActive(!isLinkActive);
                      }}>
                        <Link color={'#fff'} size={25} />
                      </button>
                      <button className={isMoveActive ? "pin-icon-btn-active" : 'pin-icon-btn'} onClick={(e) => {
                        e.stopPropagation();
                        setIsMoveActive(!isMoveActive);
                      }}>
                        <Move color={'#fff'} size={25} />
                      </button>

                    </div>
                    {/* controller for zoomIn and zoomOut */}

                  </div>
                </div>
                <div style={{ position: "absolute", bottom: "3vh", right: !isShowMenu ? "26em" : "2em" }}>
                  <div className='pin-zoom-controller d-flex align-items-center gap-2 justify-content-between'>
                    <button className='pin-icon-btn' onClick={zoomOut}>
                      <Minus />
                    </button>
                    <span
                      className={scale <= MIN_SCALE || scale >= MAX_SCALE ? "cursor-pointer text-primary fw-bold" : ""}
                      onClick={(scale <= MIN_SCALE || scale >= MAX_SCALE) ? resetZoom : undefined}
                      title={(scale <= MIN_SCALE || scale >= MAX_SCALE) ? "Click to reset zoom" : ""}
                    >
                      {Math.round(scale * 100)}%
                    </span>
                    <button className='pin-icon-btn' onClick={zoomIn}>
                      <Plus />
                    </button>
                  </div>
                </div>
              </div>

            </div>
            {/* Annotations Sidebar */}
            <div className={`pin-annotation-menu  d-flex flex-column h-100 ${isShowMenu && "hide-menu"} `}>
              <div className='flex-grow-1  overflow-auto ' style={{ height: "5vh" }}>

                {IsNullOrEmptyArray(highlights) ?
                  <div className='d-flex flex-column justify-content-center align-items-center h-100'>
                    <h6>Highlights not found !</h6>
                  </div>
                  : highlights.map((item, index) => (
                    <div key={item.id} className='pin-annotation cursor-pointer my-2'>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center pt-2 gap-2">
                          <HighlighterIcon color='#DDA827' />
                          <div className='d-flex flex-column justify-content-center  gap-1'>
                            <span className=''>{item.solutionId && !IsStringNullEmptyOrUndefined(item.solutionId) ? handleFetchLocationNo(item.solutionId) : `Highlights ${index + 1}`} </span>
                            <span className='pin-annotation-status'>{item.isDraft ? "Draft" : item.systemName}</span>
                          </div>
                        </div>
                        <div className='d-flex align-items-center gap-2'>
                          <Trash2 color='#FF0000' className='cursor-pointer' onClick={(e) => {
                            e.stopPropagation();
                            deleteHighlight(item.id);
                            removeHighlightFromPage(selectedPageId, item.id);
                          }} />

                          {
                            !item.isDraft && (
                              <SquareDashedMousePointer color='#DDA827' className='cursor-pointer' onClick={(e) => {
                                e.stopPropagation();
                                handleDownloadKeyPlan(item);

                              }} />
                            )
                          }
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className='d-flex flex-column gap-2'>
                <button className="btn btn-primary btn-hover" onClick={handlePublishPins} disabled={getLocalStorageItem(StorageKeyEnum.ANNOTATION_COORDINATES_FOR_WALTZ_ORDER) == JSON.stringify(removeDraftFromHighlights(highlightDataSet))}>Publish All</button>
                <button className="btn btn-primary btn-hover" onClick={() => {
                  navigate(`/manage-wall-order-solution/${orderId}?fromURL=waltz-orders`);
                }}>Close</button>
              </div>
            </div>
          </div>
        </div >
      </div >

      <SystemHighlightModel key={`${selectedHighlight}-${isOpen}`} />
      <MergeSystemModel key={`${isMergeModelOpen}`} />
      <SolutionLinkModel key={`${JSON.stringify(highlights)}`} pageDetail={selectedPDFPage} />
    </>
  )
}

export default PdfAnnotationPage